import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {AuthPref} from '../constants';

export const getMinimumPasswordLength = () =>
	parseInt(getPublicProperty(AuthPref.PASSWORD_MINIMUM_LENGTH) || '') || 1;

export default getMinimumPasswordLength;
